import * as angular from 'angular';

export type SpendLevelTypeName =
  | 'DOLLAR_MARKET_SHARE'
  | 'UNIT_MARKET_SHARE'
  | 'ABSOLUTE_DOLLARS'
  | 'ABSOLUTE_UNITS';

export interface SpendLevelType {
  name: SpendLevelTypeName;
  displayName: string;
  fieldNames: string[];
  operator?: null;
}

export default class RfpOffersService {
  baseUrl = '/aptitude/api/rfps';

  constructor(private $http) {
    'ngInject';
  }

  getRfpOffer(
    requestId: number,
    offerId: number,
    expandBuyerSavings?: boolean
  ) {
    let req;

    if (expandBuyerSavings) {
      req = this.$http.get(`${this.baseUrl}/${requestId}/offers/${offerId}`, {
        params: {
          expand: 'buyerSavings'
        }
      });
    } else {
      req = this.$http.get(`${this.baseUrl}/${requestId}/offers/${offerId}`);
    }

    return req;
  }

  validateOffer(requestId: number, offerId: number) {
    return this.getRfpOffer(requestId, offerId, true);
  }

  // TODO: Should be safe to remove the savings below threshold param. We don't use this anymore.
  updateOfferStatus(
    requestId: number,
    offerId: number,
    confirmSubmission: boolean
  ) {
    return this.$http.put(
      `${this.baseUrl}/${requestId}/offers/${offerId}/status`,
      {
        status: 'OfferSubmitted',
        ignoreSavingsBelowThreshold: !!confirmSubmission
      }
    );
  }

  updateRebateProxyAuthorization(
    requestId: number,
    offerId: number,
    rebateProxyAuthorization: boolean
  ) {
    return this.$http.put(
      `${this.baseUrl}/${requestId}/offers/${offerId}/cpa`,
      {
        rebateProxyAuthorization
      }
    );
  }

  // The old way, with OM-1 flag OFF
  retractOffer(requestId: number, offerId: number) {
    var req = this.$http.put(
      `${this.baseUrl}/${requestId}/offers/${offerId}/status`,
      {
        status: 'OfferRetracted'
      }
    );

    return req;
  }

  getProductsWithPriceIncreases(
    requestId: number,
    offerId: number
  ): ng.IPromise<any> {
    return this.$http.get(
      `${this.baseUrl}/${requestId}/offers/${offerId}/products`,
      {
        params: {
          filter: 'onlyPriceIncreases'
        }
      }
    );
  }

  getSpendLevelTypes(
    requestId: number,
    sellerId: number
  ): ng.IPromise<SpendLevelType[]> {
    return this.$http.get(
      `${this.baseUrl}/${requestId}/sellers/${sellerId}/spendleveltypes`
    );
  }
}
